if (!customElements.get("td-lp-shipping-estimate")) {
  class TdLpShippingEstimate extends HTMLElement {
    constructor() {
      super();
      
      // Get the shipping estimate from the data attribute
      this.shippingEstimate = this.querySelector('[data-th-shipping-estimate]')?.dataset.thShippingEstimate;
    }

    connectedCallback() {
      this.calculateShippingDate();
    }

    calculateShippingDate() {
      if (!this.shippingEstimate) return;

      // Helper function to get month name
      function getMonthName(monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString('en-US', { month: 'short' });
      }

      // Calculate the estimated shipping date
      const shippingDays = parseInt(this.shippingEstimate);
      let date = new Date();
      date.setDate(date.getDate() + shippingDays);
      
      const dayOfWeek = date.toLocaleString('en-US', { weekday: 'short' });
      const monthName = getMonthName(date.getMonth() + 1);
      const dayOfMonth = date.getDate();
      
      const estimatedDate = `${dayOfWeek}, ${monthName} ${dayOfMonth}`;
      
      // Update the display element
      const estimateElement = this.querySelector('[data-th-shipping-estimate]');
      if (estimateElement && estimatedDate) {
        estimateElement.textContent = estimatedDate;
      }
    }
  }

  customElements.define("td-lp-shipping-estimate", TdLpShippingEstimate);
}
